import React from "react";
import {Box} from "@bounce/shared/ui";

const MARKER_SIZE = 8;

export const ColorMarker = ({color}: {color: string}) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: "inline-block",
      flexShrink: 0,
      width: MARKER_SIZE,
      height: MARKER_SIZE,
      borderRadius: "2px",
      backgroundColor: color,
    }}
  />
);
